import React, { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import {
    IconExternal,
    Menu,
    MenuItem,
    MenuPopper,
} from '@zillow/constellation';

import { DELIMITER } from 'app/shared/constants/AnalyticsDelimiterConstants';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

import {
    GA_EVENTS as GA_EVENTS_LISTING_MODULE,
    GA_PREFIX,
} from 'app/shared/constants/AnalyticsListingModuleConstants';

import StringConstants from 'app/shared/constants/StringConstants';
import PropertyConstants from 'app/shared/constants/PropertyConstants';

import analyticsUtils from 'app/client/utils/analyticsUtils';
import stringHelper from 'app/shared/utils/stringHelper';

import { StyledDisabledMenuItem, StyledTextButton } from './StyledComponents';

const { startCaseRemoveSpace } = stringHelper;
const propTypes = {
    label: PropTypes.string.isRequired,
    size: PropTypes.string,
    status: PropTypes.string,
    syndication: PropTypes.object.isRequired,
};

const defaultProps = {
    size: 'lg',
    status: null,
};

const ConnectedNetworkView = forwardRef((props, ref) => {
    const dispatch = useDispatch();

    const {
        status,
        syndication,
        label,
        size,
    } = props;

    const { SYNDICATION_STATUS_MODAL_CLICK, SYNDICATION_STATUS_CLICK } = GA_EVENTS_LISTING_MODULE;
    const { OUTBOUND_CLICK, VIEW_SYNDICATION_STATUS } = GA_PREFIX;

    const syndicationByBrand = [
        StringConstants.UNFORMATTED_BRAND_NAMES.zillow,
        StringConstants.UNFORMATTED_BRAND_NAMES.trulia,
        StringConstants.UNFORMATTED_BRAND_NAMES.hotpads,
    ];

    const handleMenuOpen = () => {
        if (status) {
            dispatch(analyticsUtils.track.GAEventV2({
                ...SYNDICATION_STATUS_MODAL_CLICK,
                action: `${VIEW_SYNDICATION_STATUS}${DELIMITER}${stringHelper.startCaseRemoveSpace(status)}`,
            }));
        }
    };

    const handleLinkClick = (brand) => {
        dispatch(analyticsUtils.track.GAEventV2(
            AnalyticsConstants.GA_EVENTS.STATUS_LINK_CLICK,
            { action: startCaseRemoveSpace(`View${brand}URL`) }
        ));

        // connected events
        if (status) {
            dispatch(analyticsUtils.track.GAEventV2({
                ...SYNDICATION_STATUS_CLICK,
                label: `${OUTBOUND_CLICK}${DELIMITER}${stringHelper.startCaseRemoveSpace(brand)}`,
                action: `${VIEW_SYNDICATION_STATUS}${DELIMITER}${stringHelper.startCaseRemoveSpace(status)}`,
            }));
        }
    };

    const menu = (
        <Menu
            className="ConnectedNetworkView"
            ref={ref}
            {...props}
        >
            {syndicationByBrand.map((brand) => {
                const displayBrand = StringConstants.FORMATTED_BRAND_NAMES[brand];
                if (syndication[brand].status === PropertyConstants.LISTING_STATUS.POSTED) {
                    return (
                        <MenuItem
                            key={`menu-item-${brand}`}
                            as="a"
                            target="_blank"
                            href={syndication[brand].url}
                            icon={<IconExternal />}
                            onClick={() => handleLinkClick(displayBrand)}
                        >
                            {`View on ${displayBrand}`}
                        </MenuItem>
                    );
                }
                return (
                    <StyledDisabledMenuItem key={`menu-item-${brand}`} icon={<IconExternal />}>
                        {`View on ${displayBrand}`}
                    </StyledDisabledMenuItem>
                );
            })}
        </Menu>
    );

    return (
        <MenuPopper triggered={menu} onOpen={handleMenuOpen}>
            <StyledTextButton
                className="MenuContainer"
                size={size}
            >
                {label}
            </StyledTextButton>
        </MenuPopper>
    );
});

ConnectedNetworkView.propTypes = propTypes;
ConnectedNetworkView.defaultProps = defaultProps;

export default ConnectedNetworkView;
